import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c3afb44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-body grid no-gutter ml-2 mr-2 pt-2 pb-2" }

import { withDefaults, ref } from "vue";
import { get } from "@vueuse/core";
import FormBooking from "../common/form.vue";
import { IBooking } from "@/clinic/typings";

type IBodyEditSidebar = {
  booking: IBooking;
  note_symptom: string;
  changeRepeatParam: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'body',
  props: {
    booking: { default: {} as unknown as IBooking },
    note_symptom: null,
    changeRepeatParam: { type: Boolean, default: false }
  },
  emits: ["update", "changeRepeatParam"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { booking: IBooking, note_symptom: string, changeRepeatParam: boolean };




const frmBooking = ref<InstanceType<typeof FormBooking> | null>(null);

const onUpdate = (type: string) => emits("update", type);
const onChangeRepeatParam = () => emits("changeRepeatParam");

const getForm = (): HTMLFormElement => get(frmBooking)?.getForm() as HTMLFormElement;
const validate = (fieldName?: string): boolean => get(frmBooking)?.validate(fieldName) as unknown as boolean;
// eslint-disable-next-line no-undef
expose({
  getForm,
  validate,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormBooking, {
      ref_key: "frmBooking",
      ref: frmBooking,
      model: props.booking,
      hasEdit: true,
      note_symptom: props.note_symptom,
      is_free_space: props.booking.is_free_space,
      onChangeRepeatParam: onChangeRepeatParam,
      onUpdate: onUpdate
    }, null, 8, ["model", "note_symptom", "is_free_space"])
  ]))
}
}

})